<template>
  <v-card class="d-flex flex-column my-4" style="border-right: 1px solid #1976d2;">
    <div class="pa-3 border-bottom" style="background-color: #f2f2f2;">
      <h3>Webinar</h3>
      <h2>Profit Booster Professionelle Zahnreinigung <sup class="text-green">Zugabe</sup></h2>
    </div>
    
    <div class="pa-4" >
      <img
         :src="require('@/assets/site/zacoach.jpg')"
        class="text-white align-end"
        
        height="260"
      />
    </div>
    <div class="pa-4" >Wegen großere Nachfrage, haben wir einen weiteren Zusatztermin für Sie am <b>21.5.2025</b> organisiert.
    </div>
    <div class="pa-3 border-bottom" style="background-color: #f2f2f2;">
    <v-btn color="primary" to="/webinar/2" width="100%">Jetzt kostenlos teilnehmen</v-btn>
    </div>
  </v-card>
</template>

<script setup>



</script>

<style scoped>
.border-bottom {
  border-bottom: 1px solid #088a85;
}

.text-primary {
  color: #088a85;
}
</style>
